import { userConstants } from './../constants/user.constants';

let user = sessionStorage.getItem('user');
const initialState = user ? { user, isLoading: false } : {};

export function LoansCount(state = initialState, action) {
  
  console.log("inside LoansCount function", action)
  switch (action.type) {
    case userConstants.LOANCOUNT_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.LOANCOUNT_SUCCESS:
      const {res} = action
        console.log("Action", action)
      return {
        res,
        isLoading : false
      };
    case userConstants.LOANCOUNT_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}